import packageJson from '../../package.json';

const normalizedEnv = (process.env.NEXT_PUBLIC_ENV || 'local').toLowerCase();
const isProductionEnv = normalizedEnv === 'prod' || normalizedEnv === 'production';
const isProductionBuild = process.env.NODE_ENV === 'production';

const config = {
  baseURL: process.env.NEXT_PUBLIC_BASE_BACKEND_URL || 'http://localhost:3000',
  version: packageJson.version,
  env: process.env.NEXT_PUBLIC_ENV || 'local',
  baseDomain: process.env.NEXT_PUBLIC_BASE_DOMAIN || 'http://localhost:3001',
  production: isProductionEnv || isProductionBuild,
  // Meta Pixel must only fire on the real production site. `production` alone
  // is true for ANY Next build (NODE_ENV), so staging (stg.avantti.io, env
  // "dev") was sending events to the production pixel and polluting its data.
  metaPixelEnabled: isProductionEnv,
  domain: process.env.NEXT_PUBLIC_DOMAIN || 'sub.localhost:3001',
  maintenanceMode: process.env.NEXT_PUBLIC_MAINTENANCE_MODE || 'false',
  paywayPublicKey: process.env.NEXT_PUBLIC_PAYWAY_PUBLIC_KEY || 'tovPBDlVz2MjBBbSOlqD0M2IbgiY8bqx',
  // Site propio de Banco San Juan en Payway. Vacío = las promociones atadas a
  // ese site no se pueden pagar (el checkout lo avisa en vez de tokenizar con
  // la key equivocada).
  paywayBancoSanJuanPublicKey: process.env.NEXT_PUBLIC_PAYWAY_BANCO_SAN_JUAN_PUBLIC_KEY || '',
  // Avantti CRM (crm.avantti.io). The producer onboarding creates its lead there
  // before the account exists. Empty disables the lead calls (staging, local).
  crmUrl: (process.env.NEXT_PUBLIC_CRM_URL || '').replace(/\/$/, ''),
  // Cloudflare Turnstile site key for the CRM lead endpoint. Empty skips the
  // widget; the CRM only enforces it when TURNSTILE_SECRET_KEY is set.
  turnstileSiteKey: process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY || '',
  navePublicKey: process.env.NEXT_PUBLIC_NAVE_PUBLIC_KEY || 'b06704da-4b9a-4f87-81f1-a8d3a645d673',
  // Tope de cuotas del checkout de Fiserv; tiene que coincidir con FISERV_MAX_INSTALLMENTS
  // del backend. 1 = sin selector de cuotas.
  fiservMaxInstallments: Number(process.env.NEXT_PUBLIC_FISERV_MAX_INSTALLMENTS) || 1,
  defaultPlatformConfig: {
    version: packageJson.version,
    checkout_v2_mode: 'off' as const,
    payments_enabled: true,
    mercadopago_payments_enabled: true,
    uala_payments_enabled: true,
    payway_payments_enabled: true,
    nave_payments_enabled: true,
    zilo_payments_enabled: true,
    stripe_payments_enabled: true,
    fiserv_payments_enabled: true,
    manual_payments_enabled: true,
  },
};

export default config;
